import axios from 'axios';
import { store } from '../redux/store';
import { updateAutoLogout, updateTokenInfo } from '../redux/action';

let refreshPromise: Promise<any> | null = null;
const clearPromise = () => (refreshPromise = null);

const refreshToken = async () => {
  const fullAppStateString = sessionStorage.getItem('persist:root');
  if (!fullAppStateString) {
    throw new Error('App state not found in session storage');
  }

  const parsedAppState = JSON.parse(fullAppStateString);

  const parsedTokenInfo = JSON.parse(parsedAppState.tokenInfo);
  const storedRefreshToken = parsedTokenInfo.refreshToken;

  const response = await axios.post(
    `${process.env.REACT_APP_API_BASEURL}/auth/refresh-token`,
    {
      refreshToken: storedRefreshToken,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const { accessToken, refreshToken: newRefreshToken } = response.data;

  const newTokenInfo = {
    ...parsedTokenInfo,
    refreshToken: newRefreshToken,
  };
  parsedAppState.tokenInfo = JSON.stringify(newTokenInfo);
  sessionStorage.setItem('persist:root', JSON.stringify(parsedAppState));

  store.dispatch(updateTokenInfo(response.data));

  return accessToken;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

instance.interceptors.request.use(function (config) {
  const token = store.getState().tokenInfo.accessToken;
  config.headers.Authorization = token ? `Bearer ${token}` : 'No Token';
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url !== '/login' && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        if (!refreshPromise) {
          refreshPromise = refreshToken()
            .catch((err) => {
              if (err?.response?.status === 401) {
                store.dispatch(updateAutoLogout(true));

                window.location.href =
                  process.env.NODE_ENV === 'development'
                    ? '/'
                    : process.env.PUBLIC_URL || '/';
              }
            })
            .finally(clearPromise);
        }

        const token = await refreshPromise;
        originalConfig.headers.Authorization = `Bearer ${token}`;

        return instance(originalConfig);
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
